document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('CustomWholesaleForm');
  const phonePrefixSelect = document.querySelector('select[name="phone_prefix"]');
  const JSON_FILE_PATH = "https://cdn.shopify.com/s/files/1/0762/1610/7252/files/country-phone-codes.json?v=1775787485"; 

  // Function to load phone country codes
  async function loadPhoneCodes() {
     try {
      const response = await fetch(JSON_FILE_PATH);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      let phoneCountryCodes = await response.json(); 
      const seenDialCodes = new Set();
      const uniqueAndValidCountryCodes = phoneCountryCodes.filter(country => {
          if (country.dial_code && country.name) {
              if (!seenDialCodes.has(country.dial_code)) {
                  seenDialCodes.add(country.dial_code);
                  return true; 
              }
          }
          return false;
      });
      uniqueAndValidCountryCodes.sort((a, b) => {
          const cleanedDialCodeA = Number((a.dial_code || '').replace(/\D/g, ''));
          const cleanedDialCodeB = Number((b.dial_code || '').replace(/\D/g, ''));
          return cleanedDialCodeA - cleanedDialCodeB;
      });
      phonePrefixSelect.innerHTML = '';
      const defaultEmptyOption = document.createElement('option');
      defaultEmptyOption.value = '';
      defaultEmptyOption.textContent = 'Select Country Code';
      phonePrefixSelect.appendChild(defaultEmptyOption);
      uniqueAndValidCountryCodes.forEach(country => {
        const option = document.createElement('option');
        option.value = country.dial_code;
        option.textContent = `${country.dial_code}`; 
        
        if (country.dial_code === '+1') { 
          option.selected = true;
        }
        phonePrefixSelect.appendChild(option);
      });
      
      if (phonePrefixSelect.value && phonePrefixSelect.value !== '') {
          validate(phonePrefixSelect);
      }
    } catch (error) {
      console.error('Error loading phone country codes:', error);
      phonePrefixSelect.innerHTML = '<option value="">Error loading codes</option>';
    }
  }
  // Load phone codes when the page loads
  loadPhoneCodes();

  // Validation logic
  const validate = (el) => {
    const parent = el.closest('.field-item');
    const errorHint = parent ? parent.querySelector('.error-hint') : null; // Check if parent exists
    let isValid = true;
    let currentErrorMessage = "This field is required."; // Default message for required fields
    if (el.hasAttribute('required') && !el.value.trim()) {
      isValid = false;
    } 
    else if (el.type === 'email' && el.value.trim()) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
      if (!emailRegex.test(el.value.trim())) {
        isValid = false;
        currentErrorMessage = "Please enter a valid email address.";
      }
    }
    if (!isValid) {
      if (parent) {
        parent.classList.add('has-error');
      }
      if (errorHint) {
        errorHint.textContent = currentErrorMessage;
      }
      return false;
    } else {
      if (parent) {
        parent.classList.remove('has-error');
      }
      // Reset the error message to default if the field is required and now valid
      if (errorHint && el.hasAttribute('required')) {
          errorHint.textContent = "This field is required.";
      }
    }
    return true;
  };

  // Real-time validation on blur and input for required fields and email
  form.querySelectorAll('[required], input[type="email"]').forEach(input => {
    input.addEventListener('blur', () => validate(input));
    input.addEventListener('input', () => { 
        // Only re-validate on input if the field is currently showing an error
        if(input.closest('.field-item') && input.closest('.field-item').classList.contains('has-error')) {
            validate(input);
        }
    });
  });

  // Form submission handler
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    
    let isValid = true;
    // Collect all fields that need validation (required fields and email input)
    const fieldsToValidate = form.querySelectorAll('[required], input[type="email"]'); 
    
    fieldsToValidate.forEach(input => { 
        // Call validate on ALL relevant fields to ensure all errors are caught
        if(!validate(input)) {
            isValid = false;
        }
    });

    if (!isValid) {
      // Find the first element with an error and scroll to it
      const firstErrorField = form.querySelector('.field-item.has-error');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    const submitBtn = document.getElementById('FormSubmitBtn');
    submitBtn.disabled = true;
    submitBtn.innerText = 'Sending...';

    // Data packaging
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    fetch('/apps/faithtag-api/shopify/custom/sendEmail', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(res => {
      if(res.ok) { 
       form.reset();
      }
    })
    .catch(() => alert('Network error.'))
    .finally(() => {
      submitBtn.disabled = false;
      submitBtn.innerText = 'Submit';
    });
  });
});